import React, { useCallback, memo } from "react";

import InvoiceType from "@/enum/InvoiceType";

import OrderDTO from "@/dto/order/OrderDTO";

type Props = {
    order: OrderDTO;
};

// 发票信息列
const InvoiceInfoColumn: React.FC<Props> = ({ order }) => {
    const buildInvoiceInfoContent = useCallback(() => {
        const { invoiceInfo } = order;
        if (!invoiceInfo) {
            return "";
        }

        const { invoiceTitle, invoiceType, invoiceContent } = invoiceInfo;

        if (!invoiceType && !invoiceTitle) {
            return "";
        }

        let invoiceTypeName;
        if (invoiceType === InvoiceType.NORMAL_INVOICE) {
            invoiceTypeName = "普通发票";
        } else if (invoiceType === InvoiceType.E_INVOICE) {
            invoiceTypeName = "电子发票";
        } else if (invoiceType === InvoiceType.VALUE_ADDED_TAX_INVOICE) {
            invoiceTypeName = "增值税发票";
        }

        const buffer = [];
        if (invoiceTypeName) {
            buffer.push(`类型:${invoiceTypeName}`);
        }

        if (invoiceTitle) {
            buffer.push(`抬头:${invoiceTitle}`);
        }

        if (invoiceContent) {
            buffer.push(`内容:${invoiceContent}`);
        }

        return buffer.join(",");
    }, [order]);

    return <td>{buildInvoiceInfoContent()}</td>;
};

const isEqualFn = (prev: Props, next: Props) => {
    if (!prev.order.invoiceInfo || !next.order.invoiceInfo) return prev.order.invoiceInfo === prev.order.invoiceInfo;

    const {
        invoiceTitle: pInvoiceTitle,
        invoiceType: pInvoiceType,
        invoiceContent: pInvoiceContent,
    } = prev.order?.invoiceInfo;
    const { invoiceTitle, invoiceType, invoiceContent } = next.order?.invoiceInfo;

    return pInvoiceTitle === invoiceTitle && pInvoiceType === invoiceType && pInvoiceContent === invoiceContent;
};

export default memo(InvoiceInfoColumn, isEqualFn);
